export const ChevronRightIcon = ({ className }) => {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons / bx-chevron-right">
    <path id="Vector" d="M10.707 17.707L16.414 12L10.707 6.29297L9.293 7.70697L13.586 12L9.293 16.293L10.707 17.707Z" fill="currentColor"/>
    </g>
    </svg>
  )
}